import { render, staticRenderFns } from "./BaseDepartmentSelector.vue?vue&type=template&id=7f4edb9d"
import script from "./BaseDepartmentSelector.vue?vue&type=script&lang=js"
export * from "./BaseDepartmentSelector.vue?vue&type=script&lang=js"
import style0 from "./BaseDepartmentSelector.vue?vue&type=style&index=0&id=7f4edb9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports